/* REPLACEMENT FILE — Existing Theme path in the 29SEP2026 14:07 source Theme. */
/* CANFOTO — E1-F07B
   BROAD PDP CATALOG ADMISSION ROLLOUT — R1

   Final Stage-1 route:
   current PDP -> existing Full-NORA admission ->
     STANDARD_PDP fail-closed
     OR
     PANEL family-pack sealed V27
     OR
     COB Motor Top5 -> sealed V27

   No scoring/ranking/F-P/setup-truth/commerce owner is created here.
   This file only orchestrates already-sealed owners on the broad catalog. */
(() => {
  'use strict';

  const VERSION='CANFOTO-ETAP2-R6-2H-F-R1.1-EAGER-INTEGRITY-GUARD-BOOTSTRAP';
  const sleep=ms=>new Promise(resolve=>setTimeout(resolve,ms));
  const clean=v=>String(v??'').replace(/\s+/g,' ').trim();

  const parseJson=id=>{
    try{return JSON.parse(document.getElementById(id)?.textContent||'{}')}
    catch(_){return {}}
  };

  const manifest=parseJson('canfotoPdpBroadRolloutContext')||{};
  const frozenMode=clean(manifest.productionMode)==='FROZEN_CANONICAL_SNAPSHOT';
  const params=new URLSearchParams(location.search);
  const pathHandle=(location.pathname.match(/^\/products\/([^/?#]+)/)||[])[1]||'';

  const state=window.CANFOTO_E1_F07B_BROAD_ROLLOUT={
    version:VERSION,
    status:'STARTING',
    productHandle:pathHandle,
    admission:null,
    family:'',
    engineOwner:'',
    mode:'',
    productionMode:frozenMode?'FROZEN_CANONICAL_SNAPSHOT':'LEGACY',
    frozenSnapshotVersion:clean(manifest.frozenSnapshotVersion),
    integrityGuardReady:false,
    integrityGuardVersion:'',
    loadedAssets:[],
    reusedAssets:[],
    fullNora:false,
    standardPdp:false,
    setupMounted:false,
    bindingReady:false,
    revealParity:false,
    readyPromiseObserved:false,
    readyPromiseResolved:false,
    legacyPresentationAssetsSuppressed:[],
    panelRuntimeParity:false,
    panelLivePendingEntered:false,
    panelLiveRevealAfterBinding:false,
    presentationCalibrationVersion:'',
    pilotPresentationParityVersion:'',
    sealedOwnerPresentationVersion:'',
    fontPackVersion:'',
    fontPackStatus:'NOT_REQUESTED',
    loaderParityVersion:'',
    loaderMounted:false,
    loaderWaveCount:0,
    loaderProgressPercent:0,
    loaderProgressStep:'',
    loaderProgressLabel:'',
    loaderHistory:[],
    loaderRevealDelayMs:null,
    error:''
  };

  if(window.__CANFOTO_E1_F07B_BROAD_ROLLOUT__) return;
  window.__CANFOTO_E1_F07B_BROAD_ROLLOUT__=true;

  if(location.pathname==='/products_preview'){
    state.status='SKIPPED_DRAFT_PREVIEW_OWNER';
    return;
  }
  if(!pathHandle){
    state.status='SKIPPED_NOT_PRODUCT';
    return;
  }

  /* Existing exact pilot QA/share chain is already sealed.
     Do not create a second owner when that explicit test path is active. */
  const exactPilotHandles=new Set([
    'gdx-exc-220c-ii-bi-color-led-video-isigi',
    'gdx-ml-200r-ii-200w-rgb-profesyonel-studyo-ve-urun-cekim-isik-kiti',
    'gdx-cf-1000r-rgb-led-video-isigi',
    'gdx-p-750c-ii-bicolor-canli-yayin-ve-roportaj-isik-kaynagi'
  ]);
  const qa=params.get('cf_profile_qa')==='1';
  const share=params.get('nora_share')==='setup'||location.hash==='#nora-urun-kurulumu';
  if(exactPilotHandles.has(pathHandle)&&(qa||share)){
    state.status='SKIPPED_EXISTING_SEALED_PILOT_CHAIN';
    return;
  }

  const waitFor=async(getter,timeout=45000,step=80)=>{
    const started=performance.now();
    while(performance.now()-started<timeout){
      try{
        const v=getter();
        if(v) return v;
      }catch(_){}
      await sleep(step);
    }
    return null;
  };

  const loadScript=async(src,label)=>{
    if(!src) throw new Error('ASSET_URL_MISSING:'+label);
    const absolute=new URL(src,location.href).href;
    const existing=[...document.scripts].find(x=>x.src===absolute);
    if(existing){
      state.reusedAssets.push(label);
      return 'REUSED';
    }
    await new Promise((resolve,reject)=>{
      const s=document.createElement('script');
      s.src=absolute;
      s.async=false;
      s.dataset.canfotoE1F07b=label;
      s.onload=()=>resolve();
      s.onerror=()=>reject(new Error('LOAD_FAILED:'+label));
      document.head.appendChild(s);
    });
    state.loadedAssets.push(label);
    return 'LOADED';
  };

  const loadAdmission=async()=>{
    if(window.CANFOTO_PDP_FULL_NORA_ADMISSION_READY){
      return await window.CANFOTO_PDP_FULL_NORA_ADMISSION_READY;
    }

    state.status='LOADING_ADMISSION';
    await loadScript(manifest.admissionUrl,'ADMISSION');

    const promise=await waitFor(
      ()=>window.CANFOTO_PDP_FULL_NORA_ADMISSION_READY||null,
      6000
    );
    if(promise&&typeof promise.then==='function') return await promise;

    return await waitFor(
      ()=>window.CANFOTO_PDP_FULL_NORA_ADMISSION||null,
      35000
    );
  };

  const SEALED_FONT_PACK_VERSION='CANFOTO-REV85-SEALED-9STYLE-FONT-PACK-R1';
  const SEALED_FONT_PACK_HREF="https://fonts.googleapis.com/css2?family=Archivo+Black&family=Bodoni+Moda:opsz,wght@6..96,500;6..96,700&family=Cormorant+Garamond:wght@500;600;700&family=IBM+Plex+Mono:wght@400;600;700&family=Inter:wght@400;500;600;700;800;900&family=Libre+Baskerville:wght@400;700&family=Manrope:wght@400;500;600;700;800&family=Playfair+Display:wght@600;700;800&family=Space+Grotesk:wght@500;600;700&family=Syne:wght@600;700;800&display=swap";
  const SEALED_PRESENTATION_OWNER_VERSION='CANFOTO-PDP-V27-SEALED-OWNER-INLINE';
  const LOADING_UI_VERSION='CANFOTO-E1-F06P-R3B-NORA-SETUP-READINESS-UI-R1';

  const installSealedFontPack=()=>{
    const id='canfotoE1F07bR2eSealedFontPack';
    const existing=document.getElementById(id);
    if(existing){
      state.fontPackVersion=SEALED_FONT_PACK_VERSION;
      state.fontPackStatus=existing.dataset.ready==='1'?'READY':'LOADING';
      return existing;
    }

    const preconnect=(id,href,crossOrigin)=>{
      if(document.getElementById(id)) return;
      const link=document.createElement('link');
      link.id=id;
      link.rel='preconnect';
      link.href=href;
      if(crossOrigin) link.crossOrigin='anonymous';
      document.head.appendChild(link);
    };

    preconnect('canfotoE1F07bR2eFontsGoogleapisPreconnect','https://fonts.googleapis.com');
    preconnect('canfotoE1F07bR2eFontsGstaticPreconnect','https://fonts.gstatic.com',true);

    const link=document.createElement('link');
    link.id=id;
    link.rel='stylesheet';
    link.href=SEALED_FONT_PACK_HREF;
    link.dataset.canfotoSealedFontPack=SEALED_FONT_PACK_VERSION;
    link.dataset.ready='0';
    state.fontPackVersion=SEALED_FONT_PACK_VERSION;
    state.fontPackStatus='LOADING';
    link.addEventListener('load',()=>{
      link.dataset.ready='1';
      state.fontPackStatus='READY';
      window.dispatchEvent(new CustomEvent('canfoto:e1-f07b-r2e-font-pack-ready',{detail:{version:SEALED_FONT_PACK_VERSION}}));
    },{once:true});
    link.addEventListener('error',()=>{
      link.dataset.ready='-1';
      state.fontPackStatus='ERROR';
    },{once:true});
    document.head.appendChild(link);
    return link;
  };

  const ensureLoaderStyle=()=>{
    if(document.getElementById('canfotoE1F07bR2eExactPilotLoaderStyle')) return;
    const style=document.createElement('style');
    style.id='canfotoE1F07bR2eExactPilotLoaderStyle';
    style.dataset.canfotoLoaderSource=LOADING_UI_VERSION;
    style.textContent=`
      html.canfoto-e1-f07b-cob-pending [data-nora-pdp-setup],
      html.canfoto-r62e-panel-live-pending [data-nora-pdp-setup]{
        position:relative !important;
        visibility:hidden !important;
        pointer-events:none !important;
      }
      html.canfoto-e1-f07b-cob-pending [data-nora-pdp-setup] > .canfoto-nora-setup-readiness,
      html.canfoto-r62e-panel-live-pending [data-nora-pdp-setup] > .canfoto-nora-setup-readiness{
        visibility:visible !important;
        pointer-events:none !important;
      }
      .canfoto-nora-setup-readiness{
        position:absolute;
        inset:0;
        z-index:2147482000;
        display:grid;
        place-items:center;
        padding:clamp(18px,3vw,34px);
        overflow:hidden;
        border-radius:inherit;
        background:
          radial-gradient(circle at 18% 10%,color-mix(in srgb,var(--nps-accent) 12%,transparent),transparent 36%),
          var(--nps-surface,#0e1822);
        color:var(--nps-fg,#edf5f7);
        opacity:1;
        transition:opacity .18s ease;
      }
      .canfoto-nora-setup-readiness.is-leaving{opacity:0}
      .canfoto-nora-setup-readiness__card{
        width:min(620px,100%);
        border:1px solid color-mix(in srgb,var(--nps-accent) 58%,var(--nps-line) 42%);
        border-radius:var(--nps-control-radius,18px);
        background:
          linear-gradient(145deg,
            color-mix(in srgb,var(--nps-surface) 94%,var(--nps-accent) 6%),
            color-mix(in srgb,var(--nps-surface) 86%,var(--nps-bg) 14%)
          );
        box-shadow:0 18px 52px color-mix(in srgb,var(--nps-bg) 34%,transparent);
        padding:clamp(20px,3vw,28px);
      }
      .canfoto-nora-setup-readiness__eyebrow{
        font:900 10px/1.2 'IBM Plex Mono',monospace;
        letter-spacing:.13em;
        text-transform:uppercase;
        color:var(--nps-accent);
      }
      .canfoto-nora-setup-readiness__context{
        display:inline-flex;
        margin-top:10px;
        padding:6px 10px;
        border:1px solid color-mix(in srgb,var(--nps-accent) 44%,transparent);
        border-radius:999px;
        background:color-mix(in srgb,var(--nps-accent) 10%,transparent);
        color:color-mix(in srgb,var(--nps-accent) 84%,var(--nps-fg) 16%);
        font:900 9px/1 'IBM Plex Mono',monospace;
        letter-spacing:.08em;
        text-transform:uppercase;
      }
      .canfoto-nora-setup-readiness__title{
        margin:13px 0 0;
        font-family:var(--display,var(--body,Inter,sans-serif));
        font-size:clamp(22px,2.6vw,31px);
        line-height:1.08;
        letter-spacing:-.035em;
        color:var(--nps-fg);
      }
      .canfoto-nora-setup-readiness__label{
        min-height:42px;
        margin:10px 0 0;
        font:750 13px/1.5 var(--body,Inter,sans-serif);
        color:var(--nps-muted);
      }
      .canfoto-nora-setup-readiness__wave{
        height:42px;
        display:flex;
        align-items:stretch;
        gap:7px;
        margin-top:18px;
        overflow:hidden;
      }
      .canfoto-nora-setup-readiness__wave span{
        flex:1;
        min-width:0;
        height:100%;
        border-radius:999px;
        background:linear-gradient(
          180deg,
          color-mix(in srgb,var(--nps-accent) 78%,#fff 22%),
          var(--nps-accent) 52%,
          color-mix(in srgb,var(--nps-accent) 64%,var(--nps-fg) 36%)
        );
        opacity:.72;
        transform:scaleY(.18);
        transform-origin:center bottom;
        will-change:transform,opacity;
        animation:canfotoNoraSetupWave 1.02s ease-in-out infinite alternate;
      }
      .canfoto-nora-setup-readiness__wave span:nth-child(2){animation-delay:.09s}
      .canfoto-nora-setup-readiness__wave span:nth-child(3){animation-delay:.18s}
      .canfoto-nora-setup-readiness__wave span:nth-child(4){animation-delay:.27s}
      .canfoto-nora-setup-readiness__wave span:nth-child(5){animation-delay:.36s}
      .canfoto-nora-setup-readiness__wave span:nth-child(6){animation-delay:.45s}
      @keyframes canfotoNoraSetupWave{
        0%{transform:scaleY(.18);opacity:.48}
        55%{transform:scaleY(.72);opacity:.82}
        100%{transform:scaleY(1);opacity:1}
      }
      .canfoto-nora-setup-readiness__track{
        height:9px;
        margin-top:12px;
        border-radius:999px;
        overflow:hidden;
        background:color-mix(in srgb,var(--nps-bg) 76%,var(--nps-fg) 24%);
        border:1px solid color-mix(in srgb,var(--nps-accent) 28%,transparent);
      }
      .canfoto-nora-setup-readiness__bar{
        height:100%;
        width:0;
        border-radius:inherit;
        background:linear-gradient(
          90deg,
          color-mix(in srgb,var(--nps-accent) 62%,var(--nps-fg) 38%),
          var(--nps-accent),
          color-mix(in srgb,var(--nps-accent) 74%,#fff 26%)
        );
        transition:width .28s cubic-bezier(.2,.8,.2,1);
      }
      .canfoto-nora-setup-readiness__meta{
        display:flex;
        justify-content:space-between;
        gap:12px;
        margin-top:9px;
        font:850 10px/1.2 'IBM Plex Mono',monospace;
        color:var(--nps-muted);
      }
      .canfoto-nora-setup-readiness[data-state="done"] .canfoto-nora-setup-readiness__bar{
        background:linear-gradient(
          90deg,
          color-mix(in srgb,var(--nps-accent) 70%,var(--nps-fg) 30%),
          var(--nps-accent)
        );
      }
      .canfoto-nora-setup-readiness[data-state="fail"] .canfoto-nora-setup-readiness__bar{
        background:#d69025;
      }
      .canfoto-nora-setup-readiness[data-state="fail"] .canfoto-nora-setup-readiness__wave span{
        background:linear-gradient(180deg,#d69025,var(--nps-accent));
        animation-duration:1.35s;
      }
      @media(max-width:760px){
        .canfoto-nora-setup-readiness{padding:14px}
        .canfoto-nora-setup-readiness__card{padding:20px 17px}
        .canfoto-nora-setup-readiness__title{font-size:22px}
        .canfoto-nora-setup-readiness__label{font-size:13px;min-height:44px}
        .canfoto-nora-setup-readiness__wave{height:44px;gap:6px}
        .canfoto-nora-setup-readiness__track{height:10px}
      }
      @media(prefers-reduced-motion:reduce){
        .canfoto-nora-setup-readiness__wave span{animation-duration:2.2s}
        .canfoto-nora-setup-readiness__bar{transition-duration:.01ms}
        .canfoto-nora-setup-readiness{transition-duration:.01ms}
      }
    `;
    document.head.appendChild(style);
  };

  let loader=null;
  let loaderMountedAt=null;
  let progressWatchTimer=null;

  const loaderRoot=()=>document.querySelector(
    '[data-nora-pdp-setup] > [data-canfoto-nora-setup-readiness="1"]'
  );

  const progress=(pct,label,step)=>{
    const next=Math.max(state.loaderProgressPercent||0,Math.min(100,Math.round(Number(pct)||0)));
    state.loaderProgressPercent=next;
    state.loaderProgressLabel=clean(label);
    state.loaderProgressStep=clean(step);
    state.loaderHistory.push({
      at:Math.round(performance.now()-(loaderMountedAt||performance.now())),
      percent:next,
      step:state.loaderProgressStep
    });
    if(state.loaderHistory.length>30) state.loaderHistory.shift();

    const node=loaderRoot()||loader;
    if(!node) return;
    node.querySelector('[data-loader-bar]')?.style.setProperty('width',next+'%');
    const lab=node.querySelector('[data-loader-label]');
    const stp=node.querySelector('[data-loader-step]');
    const percent=node.querySelector('[data-loader-percent]');
    if(lab) lab.textContent=state.loaderProgressLabel;
    if(stp) stp.textContent=state.loaderProgressStep;
    if(percent) percent.textContent=next+'%';
  };

  const mountLoader=root=>{
    if(!root) return null;
    loader=loaderRoot();
    if(loader) return loader;
    ensureLoaderStyle();
    loader=document.createElement('div');
    loader.className='canfoto-nora-setup-readiness';
    loader.setAttribute('data-canfoto-nora-setup-readiness','1');
    loader.setAttribute('data-loader-version',LOADING_UI_VERSION);
    loader.setAttribute('data-state','loading');
    loader.innerHTML=
      '<div class="canfoto-nora-setup-readiness__card" role="status" aria-live="polite">'+
        '<div class="canfoto-nora-setup-readiness__eyebrow">NORA · ÜRÜNE ÖZEL KURULUM</div>'+
        '<div class="canfoto-nora-setup-readiness__context" data-loader-context>COB MOTOR · TOP5</div>'+
        '<div class="canfoto-nora-setup-readiness__title">Setup önerileri hazırlanıyor</div>'+
        '<div class="canfoto-nora-setup-readiness__label" data-loader-label>Kurulum alanı hazırlanıyor…</div>'+
        '<div class="canfoto-nora-setup-readiness__wave" aria-hidden="true">'+
          '<span></span><span></span><span></span><span></span><span></span><span></span>'+
        '</div>'+
        '<div class="canfoto-nora-setup-readiness__track" aria-hidden="true">'+
          '<div class="canfoto-nora-setup-readiness__bar" data-loader-bar></div>'+
        '</div>'+
        '<div class="canfoto-nora-setup-readiness__meta">'+
          '<span data-loader-step>Başlatılıyor</span>'+
          '<span data-loader-percent>12%</span>'+
        '</div>'+
      '</div>';
    root.appendChild(loader);
    root.setAttribute('aria-busy','true');
    loaderMountedAt=performance.now();
    state.loaderParityVersion=LOADING_UI_VERSION;
    state.loaderMounted=true;
    state.loaderWaveCount=loader.querySelectorAll('.canfoto-nora-setup-readiness__wave span').length;
    progress(12,'Kurulum alanı hazırlanıyor…','Başlatılıyor');
    return loader;
  };

  const startCobProgressWatch=()=>{
    if(progressWatchTimer) return;
    progressWatchTimer=window.setInterval(()=>{
      const engine=window.CANFOTO_PDP_ENGINE_SHADOW_BOOT;
      if(engine?.status==='FETCHING_CANONICAL_BRIDGE'){
        progress(50,'Ürün verileri eşleştiriliyor…','Veriler eşleştiriliyor');
      }else if(engine?.status==='LOADING_CANONICAL_ENGINE_ASSETS'){
        progress(58,'Kurulum kuralları hazırlanıyor…','Kurallar yükleniyor');
      }else if(engine?.status==='BUILDING_READ_ONLY_VIEW_MODEL'){
        progress(68,'Amaç ve setup adayları değerlendiriliyor…','Adaylar hazırlanıyor');
      }else if(engine?.status==='READY'){
        progress(74,'Motor verileri hazır. Top 5 seçiliyor…','Top 5 hazırlanıyor');
      }

      if(window.CANFOTO_PDP_FIVE_CONTEXT_SHADOW?.selectedCount===5 &&
         window.CANFOTO_PDP_FIVE_CONTEXT_SHADOW_BOOT?.status==='READY'){
        progress(84,'En uygun 5 setup doğrulanıyor…','Top 5 doğrulanıyor');
      }

      if(window.CANFOTO_PDP_V27_SCHEMATIC?.render){
        progress(90,'Şema ve NORA sunumu hazırlanıyor…','Sunum hazırlanıyor');
      }

      if(window.CANFOTO_E1_F03B_COB_TOP5_V27_BINDING?.status==='READY'){
        progress(96,'Setup alanı son kez doğrulanıyor…','Son kontrol');
      }
    },80);
  };

  const stopCobProgressWatch=()=>{
    if(progressWatchTimer){
      clearInterval(progressWatchTimer);
      progressWatchTimer=null;
    }
  };

  const removeLoader=root=>{
    stopCobProgressWatch();
    const node=loaderRoot()||loader;
    state.loaderRevealDelayMs=loaderMountedAt==null?null:Math.round(performance.now()-loaderMountedAt);
    if(node){
      node.setAttribute('data-state','done');
    }
    document.documentElement.classList.remove('canfoto-e1-f07b-cob-pending');
    document.documentElement.classList.remove('canfoto-r62e-panel-live-pending');
    if(root) root.setAttribute('aria-busy','false');
    if(node){
      requestAnimationFrame(()=>requestAnimationFrame(()=>{
        node.classList.add('is-leaving');
        window.setTimeout(()=>{try{node.remove()}catch(_){}},190);
      }));
    }
  };

  const installSealedPresentationOwner=()=>{
    /* E1-F07B R2E corrective activation:
       - R2D broad presentation overrides remain removed.
       - The exact sealed V27 inline owner remains the ONLY presentation owner.
       - Broad non-pilot PDPs may not have that owner active in the document because
         the historical Liquid render is pilot-scoped.
       - The server-rendered template carrier is inert on STANDARD PDP and is activated
         only after Full-NORA admission + sealed adapter readiness reach this function.
       - No CSS is reconstructed or duplicated in JavaScript. */
    document.getElementById('canfotoE1F07bR2dPilotPresentationParity')?.remove();

    let owner=document.getElementById('canfoto-pdp-v27-sealed-owner-inline');

    if(!owner){
      const carrier=document.getElementById('canfotoPdpV27SealedOwnerTemplate');
      if(carrier?.content){
        document.head.appendChild(carrier.content.cloneNode(true));
        owner=document.getElementById('canfoto-pdp-v27-sealed-owner-inline');
      }
    }

    if(!owner) throw new Error('SEALED_V27_INLINE_PRESENTATION_OWNER_MISSING');

    state.presentationCalibrationVersion=SEALED_PRESENTATION_OWNER_VERSION;
    state.pilotPresentationParityVersion=SEALED_PRESENTATION_OWNER_VERSION;
    state.sealedOwnerPresentationVersion=SEALED_PRESENTATION_OWNER_VERSION;
    return owner;
  };

  const suppressLegacyCobPresentationAssets=()=>{
    const node=document.getElementById('canfotoPdpCobCoreAssetManifest');
    if(!node) throw new Error('COB_CORE_ASSET_MANIFEST_MISSING');

    let list=[];
    try{list=JSON.parse(node.textContent||'[]')}catch(_){
      throw new Error('COB_CORE_ASSET_MANIFEST_PARSE_FAILED');
    }
    if(!Array.isArray(list)||list.length<14){
      throw new Error('COB_CORE_ASSET_MANIFEST_INVALID');
    }

    const legacyNames=new Set([
      'canfoto-pdp-setup-viewer.js',
      'canfoto-pdp-setup-share.js'
    ]);

    const kept=[];
    const removed=[];
    for(const src of list){
      let name='';
      try{name=new URL(src,location.href).pathname.split('/').pop()||''}catch(_){}
      if(legacyNames.has(name)) removed.push(name);
      else kept.push(src);
    }

    node.textContent=JSON.stringify(kept);
    state.legacyPresentationAssetsSuppressed=[...new Set(removed)];
    return kept;
  };

  const failClosed=(error)=>{
    stopCobProgressWatch();
    state.status='ERROR_FAIL_CLOSED';
    state.error=clean(error?.message||error);
    document.documentElement.classList.remove('canfoto-e1-f07b-cob-pending');
    document.documentElement.classList.remove('canfoto-r62e-panel-live-pending');
    const root=document.querySelector('[data-nora-pdp-setup]');
    try{root?.closest('[data-canfoto-v27-sealed-shop-page]')?.remove()}catch(_){}
    try{root?.remove()}catch(_){}
    console.error('[CANFOTO E1-F07B]',state.error);
  };

  const loadSealedShell=async(admission)=>{
    state.status='LOADING_SEALED_PRESENTATION';
    installSealedFontPack();
    progress(24,'Ürün ve motor uygunluğu doğrulanıyor…','Uygunluk kontrolü');

    await loadScript(manifest.sealedConfigsUrl,'SEALED_CONFIGS');
    await loadScript(manifest.panelBicolorUrl,'PANEL_BICOLOR_CONFIG');
    await loadScript(manifest.scenarioPackUrl,'COB_BICOLOR_SCENARIO_PACK');
    await loadScript(manifest.adapterUrl,'SEALED_ADAPTER');

    /* R2 ROOT FIX
       waitFor() is async. If its getter directly returns a Promise, JS Promise
       adoption unwraps it and waitFor resolves to the Promise's final value.
       R1 then tested that resolved DOM section for `.then` and falsely reported
       SEALED_ADAPTER_READY_PROMISE_MISSING.

       Wrap the Promise in a plain object so waitFor cannot adopt/flatten it. */
    const readyHolder=await waitFor(()=>{
      const promise=window.CANFOTO_V27_EXACT_PILOT_READY;
      return promise&&typeof promise.then==='function'
        ? {promise}
        : null;
    },8000);

    if(!readyHolder?.promise) throw new Error('SEALED_ADAPTER_READY_PROMISE_MISSING');

    state.readyPromiseObserved=true;
    await readyHolder.promise;
    state.readyPromiseResolved=true;

    const root=await waitFor(()=>document.querySelector('[data-nora-pdp-setup]'),12000);
    if(!root) throw new Error('SEALED_SETUP_ROOT_MISSING');

    root.dataset.canfotoE1F07bBroad='1';
    installSealedPresentationOwner();
    state.setupMounted=true;

    if(admission.engineOwner==='GDX_COB_LED_V5'){
      loader=mountLoader(root);
      progress(42,'COB motor verileri hazırlanıyor…','Motor hazırlanıyor');
    }

    await loadScript(manifest.runtimeUrl,'SEALED_RUNTIME');
    window.__CANFOTO_V27_EXACT_RUNTIME_LOADED__=true;
    window.dispatchEvent(new CustomEvent('canfoto:v27-exact-pilot-ready'));

    return root;
  };

  const ensureFrozenIntegrityGuard=async()=>{
    if(!frozenMode) return null;
    state.status='WAITING_FROZEN_INTEGRITY_GUARD';

    const guard=await waitFor(
      ()=>window.CANFOTO_R62HF_FROZEN_INTEGRITY_GUARD||null,
      12000,
      50
    );

    if(!guard) throw new Error('FROZEN_INTEGRITY_GUARD_BOOTSTRAP_NOT_READY');
    if(clean(guard.version)!=='CANFOTO-ETAP2-R6-2H-F-FROZEN-INTEGRITY-GUARD-V1')
      throw new Error('FROZEN_INTEGRITY_GUARD_VERSION_MISMATCH:'+clean(guard.version));

    state.integrityGuardReady=true;
    state.integrityGuardVersion=clean(guard.version);
    return guard;
  };

  const startPanel=async(admission)=>{
    state.mode=frozenMode?(admission.familyKey==='PANEL-RGB'?'panel-rgb-frozen-top5':'panel-bicolor-frozen-top5'):(admission.familyKey==='PANEL-RGB'?'panel-rgb-live-top5':'panel-bicolor-live-top5');
    state.panelLivePendingEntered=true;
    document.documentElement.classList.add('canfoto-r62e-panel-live-pending');

    const root=await loadSealedShell(admission);

    loader=mountLoader(root);
    const loaderContext=loader?.querySelector('[data-loader-context]');
    if(loaderContext) loaderContext.textContent=frozenMode?'FROZEN SNAPSHOT · TOP5':'PANEL MOTOR · TOP5';
    progress(38,'Panel motoru ürün bağlamında hazırlanıyor…','Motor hazırlanıyor');

    const liveBinding=await waitFor(()=>{
      const bridge=window.CANFOTO_R6_PANEL_PDP_CANONICAL_BRIDGE;
      const s=bridge?.getState?.();
      return ((frozenMode&&s?.status==='READY_FROZEN_CANONICAL_TOP5')||(!frozenMode&&s?.status==='READY_LIVE_CANONICAL_TOP5')) &&
        s?.selectedCount===5 &&
        s?.visibleCanonical===true
        ? s
        : null;
    },70000);

    if(!liveBinding) throw new Error(frozenMode?'PANEL_FROZEN_CANONICAL_TOP5_NOT_READY':'PANEL_LIVE_CANONICAL_TOP5_NOT_READY');

    progress(92,'Canlı Top 5 ve Shared V27 eşleşmesi doğrulanıyor…','Son kontrol');

    const tabs=[...root.querySelectorAll('.nps-scenario-btn[data-setup-record-id]')];
    const visibleIds=tabs.map(x=>clean(x.dataset.setupRecordId)).filter(Boolean);
    const topIds=(window.CANFOTO_R6_PANEL_PDP_CANONICAL_BRIDGE?.getTop5?.()||[])
      .map(x=>clean(x.canonicalSetupRecordId||x.setupRecordId)).filter(Boolean);
    const svg=root.querySelector('.nps-svg');

    const parity=
      tabs.length===5 &&
      visibleIds.length===5 &&
      topIds.length===5 &&
      visibleIds.every((id,i)=>id===topIds[i]) &&
      !visibleIds.some(id=>id.startsWith('PANEL_STATIC::')) &&
      svg?.dataset?.motorTruthOwner==='GDX_PANEL_LED_V4' &&
      svg?.dataset?.presentationOwner==='CANFOTO_PDP_V27_SCHEMATIC' &&
      (!frozenMode || svg?.dataset?.sourceBehavior==='FROZEN_CANONICAL_SNAPSHOT');

    if(!parity) throw new Error('PANEL_LIVE_TOP5_VISIBLE_PARITY_FAILED');

    state.panelRuntimeParity=true;
    state.status=frozenMode?'READY_PANEL_FROZEN_TOP5':'READY_PANEL_MOTOR_TOP5';
    state.revealParity=true;
    state.fullNora=true;
    state.bindingReady=true;
    state.setupMounted=!!root;
    state.panelLiveRevealAfterBinding=true;

    progress(100,frozenMode?'Frozen Panel Top 5 hazır.':'Canlı Panel Top 5 hazır.','Tamamlandı');
    removeLoader(root);

    window.dispatchEvent(new CustomEvent('canfoto:e1-f07b-broad-pdp-ready',{detail:{...state}}));
  };

  const startCob=async(admission)=>{
    state.mode=frozenMode
      ? (admission.familyKey==='COB-RGB'?'cob-rgb-frozen-top5':'cob-bicolor-frozen-top5')
      : (admission.familyKey==='COB-RGB'
          ? ((params.get('cf_v27_family')||'').toLowerCase()==='rgb-fx'?'rgb-fx':'cob-rgb')
          : 'cob-bicolor');

    document.documentElement.classList.add('canfoto-e1-f07b-cob-pending');

    const root=await loadSealedShell(admission);

    progress(50,'Ürün verileri eşleştiriliyor…','Veriler eşleştiriliyor');

    /* Broad non-pilot Liquid context historically contains the legacy viewer/share
       presentation assets. Stage-1 broad rollout must use the SEALED V27 owner only. */
    suppressLegacyCobPresentationAssets();

    await loadScript(manifest.engineShadowUrl,'ENGINE_SHADOW');
    if(!window.CANFOTO_PDP_V27_SCHEMATIC?.render){
      await loadScript(manifest.staticCobSchematicUrl,'V27_SCHEMATIC');
    }
    startCobProgressWatch();
    progress(58,'Kurulum kuralları hazırlanıyor…','Kurallar yükleniyor');

    const top5=await waitFor(
      ()=>window.CANFOTO_PDP_FIVE_CONTEXT_SHADOW?.selectedCount===5 &&
         window.CANFOTO_PDP_FIVE_CONTEXT_SHADOW_BOOT?.status==='READY'
        ? window.CANFOTO_PDP_FIVE_CONTEXT_SHADOW
        : null,
      50000
    );
    if(!top5) throw new Error(frozenMode?'COB_FROZEN_TOP5_NOT_READY':'COB_MOTOR_TOP5_NOT_READY');
    if(frozenMode && clean(top5.sourceMode)!=='FROZEN_CANONICAL_SNAPSHOT')
      throw new Error('COB_FROZEN_SOURCE_MODE_MISMATCH');

    progress(84,frozenMode?'Frozen 5 setup doğrulanıyor…':'En uygun 5 setup doğrulanıyor…','Top 5 doğrulanıyor');

    const renderer=await waitFor(()=>window.CANFOTO_PDP_V27_SCHEMATIC?.render?window.CANFOTO_PDP_V27_SCHEMATIC:null,15000);
    if(!renderer) throw new Error('V27_SCHEMATIC_RENDERER_NOT_READY');
    progress(90,'Şema ve NORA sunumu hazırlanıyor…','Sunum hazırlanıyor');

    await loadScript(manifest.bridgeUrl,'COB_TOP5_V27_BRIDGE');

    const binding=await waitFor(
      ()=>window.CANFOTO_E1_F03B_COB_TOP5_V27_BINDING?.status==='READY'
        ? window.CANFOTO_E1_F03B_COB_TOP5_V27_BINDING
        : null,
      25000
    );
    if(!binding) throw new Error('COB_TOP5_BINDING_NOT_READY');

    progress(96,'Setup alanı son kez doğrulanıyor…','Son kontrol');

    const tabs=[...root.querySelectorAll('.nps-scenario-btn')];
    const visibleIds=tabs.map(x=>clean(x.dataset.setupRecordId)).filter(Boolean);
    const topIds=(top5.selectedSetups||[]).map(x=>clean(x?.setup?.setupRecordId)).filter(Boolean);
    const svg=root.querySelector('.nps-svg');

    const parity=
      tabs.length===5 &&
      visibleIds.length===5 &&
      topIds.length===5 &&
      visibleIds.every((id,i)=>id===topIds[i]) &&
      svg?.dataset?.motorTruthOwner==='GDX_COB_LED_V5' &&
      svg?.dataset?.presentationOwner==='CANFOTO_PDP_V27_SCHEMATIC' &&
      svg?.dataset?.sourceBehavior==='SEALED_PDP_V27_CALIBRATED_RUNTIME';

    if(!parity) throw new Error('COB_TOP5_VISIBLE_PARITY_FAILED');

    progress(100,'Setup önerileri hazır.','Tamamlandı');
    state.status=frozenMode?'READY_COB_FROZEN_TOP5':'READY_COB_MOTOR_TOP5';
    state.fullNora=true;
    state.bindingReady=true;
    state.revealParity=true;
    removeLoader(root);

    window.dispatchEvent(new CustomEvent('canfoto:e1-f07b-broad-pdp-ready',{detail:{...state}}));
  };

  (async()=>{
    try{
      const admission=await loadAdmission();
      if(!admission) throw new Error('ADMISSION_DECISION_MISSING');

      state.admission={
        engineOwner:clean(admission.engineOwner),
        familyKey:clean(admission.familyKey),
        lane:clean(admission.lane),
        routeState:clean(admission.routeState),
        reason:clean(admission.reason)
      };
      state.family=clean(admission.familyKey);
      state.engineOwner=clean(admission.engineOwner);

      const fullNora=
        admission.fullNoraCandidate===true &&
        (
          (
            admission.engineOwner==='GDX_COB_LED_V5' &&
            ['COB-RGB','COB-BICOLOR'].includes(admission.familyKey) &&
            (
              (frozenMode && admission.routeState==='READY_FOR_FROZEN_CANONICAL_BINDING') ||
              (!frozenMode && admission.routeState==='READY_FOR_MOTOR_TOP5_BINDING')
            )
          ) ||
          (
            admission.engineOwner==='GDX_PANEL_LED_V4' &&
            ['PANEL-RGB','PANEL-BICOLOR'].includes(admission.familyKey) &&
            (
              (frozenMode && admission.routeState==='READY_FOR_FROZEN_CANONICAL_BINDING') ||
              (!frozenMode && admission.routeState==='READY_FOR_FAMILY_PACK_BINDING')
            )
          )
        );

      if(!fullNora){
        state.status='STANDARD_PDP';
        state.standardPdp=true;
        state.fullNora=false;
        state.revealParity=true;
        state.setupMounted=false;
        window.dispatchEvent(new CustomEvent('canfoto:e1-f07b-standard-pdp',{detail:{...state}}));
        return;
      }

      if(frozenMode){
        await ensureFrozenIntegrityGuard();
      }

      installSealedFontPack();

      if(admission.engineOwner==='GDX_PANEL_LED_V4'){
        await startPanel(admission);
        return;
      }

      if(admission.engineOwner==='GDX_COB_LED_V5'){
        await startCob(admission);
        return;
      }

      throw new Error('FULL_NORA_OWNER_UNSUPPORTED:'+clean(admission.engineOwner));
    }catch(error){
      failClosed(error);
    }
  })();
})();